"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var axios_1 = __importDefault(require("axios"));
var app_styles_1 = __importDefault(require("./app.styles"));
var AppNavigation_1 = __importDefault(require("./components/organisms/AppNavigation/AppNavigation"));
var SportsOffer_1 = __importDefault(require("./components/organisms/SportsOffer/SportsOffer"));
var SportsOfferForm_1 = __importDefault(require("./components/organisms/SportsOfferForm/SportsOfferForm"));
var SportsQuizExport_1 = __importDefault(require("./components/organisms/SportsQuizExport/SportsQuizExport"));
var LoginForm_1 = __importDefault(require("./components/organisms/LoginForm/LoginForm"));
var columnFiltersSlice_1 = require("./store/columnFiltersSlice");
var loginState_1 = require("./types/loginState");
var Availability_1 = __importDefault(require("./components/organisms/Availability/Availability"));
var AgendaOverview_1 = __importDefault(require("./components/organisms/AgendaOverview/AgendaOverview"));
var ClinicDetail_1 = __importDefault(require("./components/organisms/ClinicDetail/ClinicDetail"));
var AvailabilityOverview_1 = __importDefault(require("./components/organisms/AvailabilityOverview/AvailabilityOverview"));
var NotAvailableRanges_1 = __importDefault(require("./components/organisms/NotAvailableRanges/NotAvailableRanges"));
var NotAvailableDays_1 = __importDefault(require("./components/organisms/NotAvailableDays/NotAvailableDays"));
var ClinicAvailability_1 = __importDefault(require("./components/organisms/ClinicAvailability/ClinicAvailability"));
var Confirmed_1 = __importDefault(require("./components/organisms/Confirmed/Confirmed"));
var App = function () {
    var dispatch = react_redux_1.useDispatch();
    var userFromStorage = localStorage.getItem('user');
    var _a = react_1.useState(userFromStorage && userFromStorage !== '' && userFromStorage.includes('{')
        ? JSON.parse(userFromStorage)
        : {
            name: 'TestAccount',
            firstTimeLogin: false,
            clinicSupplier: true,
        }), user = _a[0], setUser = _a[1];
    var _b = react_1.useState(localStorage.getItem('loginState') || loginState_1.LOGGEDOUT), loggedIn = _b[0], setLoggedIn = _b[1];
    // logout user if laravel responds with a 401
    axios_1.default.interceptors.response.use(function (response) { return response; }, function (error) {
        if (error.response.status === 401) {
            logout();
        }
        return Promise.reject(error);
    });
    // filter state on load
    react_1.useEffect(function () {
        if (loggedIn === loginState_1.LOGGEDIN) {
            axios_1.default
                .get('/api/user')
                .then(function (response) {
                if (response.status < 300) {
                    // use context to set filters
                    var context = response.data.context;
                    if (context) {
                        dispatch(columnFiltersSlice_1.setColumnFilters(context));
                    }
                }
            })
                .catch(function (error) {
                console.error(error);
            });
        }
    }, []);
    var login = function () {
        setLoggedIn(loginState_1.LOGGEDIN);
        localStorage.setItem('loginState', loginState_1.LOGGEDIN);
        axios_1.default
            .get('/api/user')
            .then(function (response) {
            if (response.status < 300) {
                setUser(response.data);
                localStorage.setItem('user', JSON.stringify(response.data));
                // use context to set filters
                var context = response.data.context;
                if (context) {
                    dispatch(columnFiltersSlice_1.setColumnFilters(context));
                }
            }
        })
            .catch(function (error) {
            console.error(error);
        });
    };
    var logout = function () {
        axios_1.default.get('/sanctum/csrf-cookie').then(function () {
            axios_1.default
                .post('/logout')
                .then(function (response) {
                if (response.status === 204) {
                    setLoggedIn(loginState_1.LOGGEDOUT);
                    dispatch(columnFiltersSlice_1.setColumnFilters([]));
                    localStorage.setItem('loginState', loginState_1.LOGGEDOUT);
                    localStorage.setItem('user', '');
                }
            })
                .catch(function (error) {
                console.error(error);
            });
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(app_styles_1.default, null,
            react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                react_1.default.createElement(AppNavigation_1.default, { username: user.name, clinicSupplier: user.clinicSupplier, logout: logout }),
                react_1.default.createElement(react_router_dom_1.Switch, null,
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/", exact: true, render: function (props) { return (react_1.default.createElement(SportsOffer_1.default, __assign({}, props, { firstTimeLogin: user.firstTimeLogin, clinicSupplier: user.clinicSupplier, loggedIn: loggedIn }))); } }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/availability", render: function (props) { return react_1.default.createElement(Availability_1.default, __assign({}, props, { username: user.name, loggedIn: loggedIn })); } }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/availability-overview", render: function (props) { return (react_1.default.createElement(AvailabilityOverview_1.default, __assign({}, props, { username: user.name, loggedIn: loggedIn }))); } }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/agenda", render: function (props) { return react_1.default.createElement(AgendaOverview_1.default, __assign({}, props, { username: user.name, loggedIn: loggedIn })); } }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/clinic/:id", render: function () { return react_1.default.createElement(ClinicDetail_1.default, { loggedIn: loggedIn }); } }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/add", render: function (props) { return react_1.default.createElement(SportsOfferForm_1.default, __assign({}, props, { loggedIn: loggedIn })); } }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/export", render: function (props) { return react_1.default.createElement(SportsQuizExport_1.default, __assign({}, props, { loggedIn: loggedIn })); } }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/availability-ranges", render: function (props) { return react_1.default.createElement(NotAvailableRanges_1.default, __assign({}, props, { loggedIn: loggedIn })); } }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/availability-days", render: function (props) { return react_1.default.createElement(NotAvailableDays_1.default, __assign({}, props, { loggedIn: loggedIn })); } }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/clinic-availability/:id", render: function (props) { return react_1.default.createElement(ClinicAvailability_1.default, __assign({}, props, { loggedIn: loggedIn })); } }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/confirmed", render: function (props) { return react_1.default.createElement(Confirmed_1.default, __assign({}, props, { loggedIn: loggedIn })); } }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/edit/:id", render: function (props) { return react_1.default.createElement(SportsOfferForm_1.default, __assign({}, props, { loggedIn: loggedIn })); } }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/login", render: function (props) { return react_1.default.createElement(LoginForm_1.default, __assign({}, props, { login: login, loggedIn: loggedIn })); } }))))));
};
exports.default = App;
